import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/services/network';
import { getTokens } from '../Auth/Auth.thunks';

export interface MultiCompanyAccessCompany {
  company_id: number;
  business_name: string;
}

export interface MultiCompanyAccessResponseData {
  current_company_id: number;
  companies: MultiCompanyAccessCompany[];
}

export interface MultiCompanyAccessApiResponse {
  data: MultiCompanyAccessResponseData;
}

export interface SelectMultiCompanyAccessArgs {
  companyId: number;
}

export interface SelectMultiCompanyAccessPayload {
  'refresh-token': string;
  company_id: number;
}

export interface SelectMultiCompanyAccessAuthResponse {
  'access-token': string;
  'refresh-token': string;
  'expires-in'?: number;
  data?: SelectMultiCompanyAccessAuthResponse;
}

export const getMultiCompanyAccess = createAsyncThunk<
  MultiCompanyAccessApiResponse,
  void,
  { rejectValue: string }
>('MULTI_COMPANY_ACCESS', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get<MultiCompanyAccessApiResponse>(
      '/accounts/mtr/auth/companies'
    );
    return response.data;
  } catch {
    return rejectWithValue('failed_to_load_companies');
  }
});

export const selectMultiCompanyAccessCompany = createAsyncThunk<
  SelectMultiCompanyAccessAuthResponse,
  SelectMultiCompanyAccessArgs,
  { rejectValue: string }
>(
  'SELECT_MULTI_COMPANY_ACCESS_COMPANY',
  async ({ companyId }, { rejectWithValue }) => {
    const { refreshToken } = getTokens();

    if (!refreshToken) {
      return rejectWithValue('missing_refresh_token');
    }

    try {
      const payload: SelectMultiCompanyAccessPayload = {
        'refresh-token': refreshToken,
        company_id: companyId,
      };

      const response = await axios.put(
        '/accounts/mtr/auth/current-company',
        payload
      );
      const authPayload = response.data.data ?? response.data;

      localStorage.setItem('PLAYMPE_AUTH', JSON.stringify(authPayload));
      return authPayload;
    } catch {
      return rejectWithValue('failed_to_select_company');
    }
  }
);

export default getMultiCompanyAccess;
